import * as React from "react";
import { formatMessage } from "lib/globalize-util";
import { ChoiceGroup, IChoiceGroupOption, mergeStyleSets } from "@nuorder/components";
import { FOLDERS } from "constants/integration/folders";
import { AssortmentType } from "containers/folders/types/base";
import { useAssortmentDialogContext, ActionsTypes } from "./context";

const classNames = mergeStyleSets({
    assortmentTypeGroup: {
        selectors: {
            " .ms-ChoiceFieldGroup-flexContainer": {
                display: "flex",
            },
            " .ms-ChoiceFieldGroup-flexContainer > :not(:first-child)": {
                marginLeft: 24,
            },
        },
    },
    assortmentOptionsExplanatory: {
        fontSize: "11px",
        color: "#585858",
    },
    assortmentOptionsText: {
        fontWeight: 600,
    },
});

const assortmentOptionsDesc = (props, description) => (
    <div className="ms-ChoiceFieldLabel">
        <div className={classNames.assortmentOptionsText} id={props.labelId}>
            {props.text}
        </div>
        <div className={classNames.assortmentOptionsExplanatory}>{formatMessage(description)}</div>
    </div>
);

const assortmentTypeOptions = () => [
    {
        key: AssortmentType.Internal,
        onRenderLabel: (props) => assortmentOptionsDesc(props, "Work with your internal team only."),
        text: formatMessage("Multi Brand"),
        "data-test": FOLDERS.CREATE_ASSORTMENT_DIALOG.TYPES.INTERNAL,
    },
    {
        key: AssortmentType.External,
        onRenderLabel: (props) => assortmentOptionsDesc(props, "Option to share externally with the brand."),
        text: formatMessage("Single Brand"),
        "data-test": FOLDERS.CREATE_ASSORTMENT_DIALOG.TYPES.EXTERNAL,
    },
];

export const AssortmentTypeSelector: React.FC<{ setAssortmentType?: (value: boolean) => void }> = ({
    setAssortmentType,
}) => {
    const { dispatch, formValues, isEditing } = useAssortmentDialogContext();

    const onChangeAssortmentType = (_: React.FormEvent<HTMLElement | HTMLInputElement>, option: IChoiceGroupOption) => {
        setAssortmentType?.(option.key === AssortmentType.External);
        dispatch({ type: ActionsTypes.UPDATE_ASSORTMENT_TYPE, payload: option.key as AssortmentType });
    };

    return (
        <ChoiceGroup
            defaultSelectedKey={isEditing ? formValues.assortmentType : AssortmentType.External}
            value={formValues.assortmentType}
            onChange={onChangeAssortmentType}
            options={assortmentTypeOptions()}
            disabled={isEditing}
            label={formatMessage("Assortment Type")}
            required={true}
            className={classNames.assortmentTypeGroup}
            data-test={FOLDERS.CREATE_ASSORTMENT_DIALOG.ASSORTMENT_TYPE}
        />
    );
};
